import css from "styled-jsx/css";
import { SMALL_MOBILE_QUERY_MAX_WIDTH } from "/constants/vp-sizes";

export const componentStyles = css`
  .manage-option {
    border-radius: 6px;
    box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.14);
    background-color: rgba(255, 255, 255, 1);
    border: 3px solid transparent;

    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    width: 327px;
    height: 232px;
    margin: 0 8px 32px 8px;

    .text-wrapper {
      display: flex;
      flex: 25;

      justify-content: center;
      align-items: center;

      .option-text {
        font-size: 1rem;
        text-align: center;
        color: white;
      }
    }
    .image-wrapper {
      flex: 75;
      padding: 0 12px 12px 12px;

      .option-image {
        width: 100%;
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
      }
    }

    &.big-image {
      margin: 0 8px;
    }

    &.selected {
      &:not(.big-image) {
        border: 3px solid rgba(2, 161, 229, 1);
      }
    }
  }

  @media (max-width: ${SMALL_MOBILE_QUERY_MAX_WIDTH}) {
    .manage-option {
      width: 278px;
      height: 197px;
    }
  }
`;
